type PolicyInfo = {
  isActive: boolean
  countryId: number
  isLeasing: boolean
  id: number
  isSubscribed?: boolean
}

export const getPolicyFilter = <T extends PolicyInfo>({
  policyList,
  countryId,
  customerHasLeasing,
  policyId,
  extraPredicate,
}: {
  policyList?: T[]
  countryId?: number
  customerHasLeasing: boolean
  policyId?: number
  extraPredicate?: (policy: T) => boolean
}) =>
  (policyList ?? []).filter(policy => {
    const policyHasSubscription = policy.isSubscribed || policyId
    const base =
      (policy.isActive && (customerHasLeasing || !policy.isLeasing)) ||
      (policyHasSubscription && (policyId === policy.id || policy.isSubscribed))
    const inSameCountry = countryId ? policy.countryId === countryId : true
    return base && inSameCountry && (extraPredicate ? extraPredicate(policy) : true)
  })

export const getOrderPolicyFilter = <T extends PolicyInfo>({
  policyList,
  customerHasLeasing,
  extraPredicate,
}: {
  policyList?: T[]
  customerHasLeasing: boolean
  extraPredicate?: (policy: T) => boolean
}) =>
  (policyList ?? []).filter(policy => {
    const base = policy.isActive && (customerHasLeasing || !policy.isLeasing)
    return base && (extraPredicate ? extraPredicate(policy) : true)
  })
